import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

// Axios base URL'ini ayarla: production'da API alt alan adını kullan
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.korkmazlarkoy.com' : 'http://localhost:5000';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const validateToken = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }

      // Token'dan kullanıcı bilgilerini çıkar (JWT decode)
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      
      if (payload.exp < currentTime) {
        // Token süresi dolmuş
        logout();
        return;
      }

      // Kullanıcı bilgilerini ayarla
      setUser({
        id: payload.userId,
        username: payload.username,
        role: payload.role
      });
    } catch (error) {
      console.error('Token validation error:', error);
      logout();
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Sayfa yüklendiğinde token kontrolü
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      // Token'ı doğrula ve kullanıcı bilgilerini al
      validateToken();
    } else {
      setLoading(false);
    }
  }, [validateToken]);

  const login = async (username, password) => {
    try {
      const response = await axios.post('/api/auth/login', { username, password });
      const { token, user } = response.data;
      
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      setUser(user);
      toast.success('Giriş başarılı!');
      return true;
    } catch (error) {
      const message = error.response?.data?.error || 'Giriş yapılamadı';
      toast.error(message);
      return false;
    }
  };

  const register = async (userData) => {
    try {
      await axios.post('/api/auth/register', userData);
      toast.success('Kayıt başarılı! Giriş yapabilirsiniz.');
      return true;
    } catch (error) {
      const message = error.response?.data?.error || 'Kayıt yapılamadı';
      toast.error(message);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    toast.success('Çıkış yapıldı');
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 